import { AtomValue } from '@approvalmax/types';
import { useSetAtom } from 'jotai';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { routeParamsState } from 'shared/states';

export const RouterPageWrapper: FC<PropsWithChildren> = (props) => {
    const { children } = props;

    const { companyId } = useParams<AtomValue<typeof routeParamsState>>();
    const setRouteParams = useSetAtom(routeParamsState);

    useEffect(() => setRouteParams({ companyId }), [companyId, setRouteParams]);

    return children;
};

RouterPageWrapper.displayName = 'RouterPageWrapper';
